export default "__VITE_ASSET__9CgG5Yy8__"